import { Button, Col, Row, Typography } from 'antd';
import React from 'react';
import { useParams } from 'react-router';
import busksellerdetail from '../services/busksellerdetail';

interface Props {
  totalWarehouse: number;
  totalProduct: number;
  warehouseData: any;
  selectedWarehouse: React.Key[];
  selectedProduct: React.Key[];
}

const SellerListDetail = ({ totalWarehouse, selectedWarehouse }: Props) => {
  const { id } = useParams<{ id: string }>();
  const handleOnExport = async () => {
    if (selectedWarehouse.length > 0) {
      const response = await busksellerdetail.exportSellerExcellWarehouseById(
        id,
        selectedWarehouse
      );
      const outputFilename = `Warehouse_240406T9g6QGJSxyR.xlsx`;

      const url = URL.createObjectURL(new Blob([response]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', outputFilename);
      document.body.appendChild(link);
      link.click();
    } else {
      const response = await busksellerdetail.exportSellerExcellWarehouse(id);
      const outputFilename = `Warehouse_240406T9g6QGJSxyR.xlsx`;

      const url = URL.createObjectURL(new Blob([response]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', outputFilename);
      document.body.appendChild(link);
      link.click();
    }
  };
  return (
    <div className="busk-sellerSubHead">
      <Row align="middle">
        <Col flex="auto">
          <Row gutter={15}>
            <Col>
              <Typography.Text>총 물류센터 {totalWarehouse}</Typography.Text>
            </Col>
            <Col>|</Col>
            <Col>
              <Typography.Text>
                선택 물류센터 {selectedWarehouse.length}
              </Typography.Text>
            </Col>
          </Row>
        </Col>
        <Col>
          <Button
            style={{
              color: 'gray'
            }}
            onClick={() => handleOnExport()}
          >
            엑셀 다운로드
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default SellerListDetail;
